import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowRight } from "lucide-react";
import { SERVICES } from "@/data/site";

export default function Services() {
  return (
    <div data-testid="services-page">
      <section className="border-b border-white/10 bg-[#111] relative grain">
        <div className="max-w-7xl mx-auto px-6 py-24">
          <p className="label-industrial text-ember mb-4">Services</p>
          <h1 className="font-display text-6xl lg:text-8xl tracking-wide text-white" data-testid="services-heading">
            WHAT WE DO
          </h1>
          <p className="mt-6 text-gray-400 max-w-xl">
            From full custom builds to a Saturday-morning WOF — cars, boats and trailers all get the same standard of work.
          </p>
        </div>
      </section>

      <section className="max-w-7xl mx-auto px-6 py-24">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-px bg-white/10 border border-white/10" data-testid="services-grid">
          {SERVICES.map((s, i) => (
            <motion.div
              key={s.slug}
              initial={{ opacity: 0, y: 24 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: (i % 2) * 0.08 }}
              className="group bg-[#111]"
              data-testid={`service-detail-${s.slug}`}
            >
              <div className="h-72 overflow-hidden">
                <img
                  src={s.image}
                  alt={s.title}
                  loading="lazy"
                  className="w-full h-full object-cover grayscale-[40%] group-hover:grayscale-0 group-hover:scale-105 transition-[filter,transform] duration-300"
                />
              </div>
              <div className="p-10 border-t-2 border-ember flex flex-col sm:flex-row sm:items-end justify-between gap-6">
                <div>
                  <h2 className="font-display text-4xl tracking-wide text-white mb-3">{s.title}</h2>
                  <p className="text-gray-400 text-sm leading-relaxed max-w-md">{s.blurb}</p>
                </div>
                <Link
                  to={`/contact?service=${s.slug}`}
                  data-testid={`service-book-${s.slug}`}
                  className="label-industrial text-ember hover:text-ember-hover transition-colors duration-150 flex items-center gap-2 shrink-0"
                >
                  Book this <ArrowRight className="w-4 h-4" />
                </Link>
              </div>
            </motion.div>
          ))}
        </div>
      </section>
    </div>
  );
}
